import { Controller } from '@hotwired/stimulus'

// Hide <table> columns
// Controller is attached to the <table> element with column targets
//
// For ex:
//    <table data-controller="toggle-table-column">
//       <th data-toggle-table-column-target="column" data-column-name="myColumnName">
//         <button data-action="change->toggle-table-column#toggleColumn" data-column-name="myColumnName">
//           Hide Column
//       <td data-toggle-table-column-target="column" data-column-name="myColumnName">
//    Click -> hides both th and td

export default class extends Controller {
    static targets = ['column', 'columnName']

    toggleColumn(event) {
        event.preventDefault()

        const { columnName } = event.currentTarget.dataset

        this.toggleColumnVisibility(columnName)

        // dispatch to window for cross turbo-frame communication
        window.dispatchEvent(
            new CustomEvent('toggle-table-column:toggled', {
                detail: {
                    columns: this.columnNameTargets.map(column => column.value),
                },
            }),
        )
    }

    toggleColumnVisibility(columnName) {
        // Iterate through all column targets and remove matching ones
        // Each td/th will have a uniqe columnName
        // Using columnName instead of index as it's more robust and easier to deal
        // with reordering
        this.columnTargets.forEach((column) => {
            if (column.dataset.columnName === columnName) {
                column.remove()
            }
        })
    }
}
